import type { Currency } from '@shared/contracts/enums'
import type { DateRangeValue } from '@shared/lib/date-range'
import { DateRangeField } from '../DateRange/DateRangeField'
import * as styles from './MetricsHeader.css'

export type MetricsHeaderProps = {
  title: string
  titleId: string
  dateRange: DateRangeValue
  onDateRangeChange: (value: DateRangeValue) => void
  periodLabel: string
  currency: Currency
  currencies: readonly Currency[]
  onCurrencyChange: (currency: Currency) => void
  currencyAriaLabel: string
}

export function MetricsHeader({
  title,
  titleId,
  dateRange,
  onDateRangeChange,
  periodLabel,
}: MetricsHeaderProps) {
  return (
    <div className={styles.root}>
      <div className={styles.headingRow}>
        <h2 id={titleId} className={styles.title}>
          {title}
        </h2>
      </div>
      <DateRangeField
        value={dateRange}
        onChange={onDateRangeChange}
        allLabel="Histórico até hoje"
      />
      {periodLabel && <p className={styles.caption}>{periodLabel} · Horário de Brasília</p>}
    </div>
  )
}
